import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import classes from './checkRequest.module.css'

export default function (props) {
  const { state, handleEditCrf } = props
  const history = useHistory()
  return (
    <button
      className='toggleEditableRequest'
      type='button'
      onClick={() => state.requestType === 'Cash Advance' ? history.push(`/CashAdvance/${state._id}`) : state.requestType === 'Liquidation' ? history.push(`/Liquidation/${state._id}`) : handleEditCrf()}
    >
      <i class='fas fa-edit'></i>
      {state.editCrfDetails === false
        ? ' ' + 'Edit CRF'
        : ' ' + 'Cancel'}
    </button>
  )
}
